import { Route, Routes, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage.jsx';
import PrivacyPage from './pages/PrivacyPage.jsx';
import TermsPage from './pages/TermsPage.jsx';
import DiagnosticPage from './pages/DiagnosticPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';

function App() {
  return (
    <Routes>
      <Route path='/' element={<HomePage />} />
      <Route path='/diagnostico' element={<DiagnosticPage />} />
      <Route path='/privacidad' element={<PrivacyPage />} />
      <Route path='/terminos' element={<TermsPage />} />
      <Route
        path='/privacidad.html'
        element={<Navigate to='/privacidad' replace />}
      />
      <Route
        path='/terminos.html'
        element={<Navigate to='/terminos' replace />}
      />
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
